export default __webpack_public_path__ + "static/media/date-icon.5fcdaddc.svg";